export const APP_DATA = {
  version: '27.3.0',
  buildNumber: 219,
};
